import React from "react";

const Loader = () => {
  return (
    <div id="preloader"></div>
  );
};

export default Loader;
